import React, { useEffect, useState } from 'react';
import { EmeraldButton } from '@emerald-react/button';
import PhaseCard from './components/PhaseCard';
import { useStyles } from './styles';
import classNames from 'classnames';
import { sdlcData } from './mocks/data';
import { Grid } from '@material-ui/core';
import { IPhaseCard } from './types';
import EllisIcon from './icons/EllisIcon';

const AiInSdlc = () => {
  const classes = useStyles();
  const expandedPhase = decodeURIComponent(
    window?.location?.hash?.substring(1),
  );

  useEffect(() => {
    // Decode the hash and remove the '#' symbol
    if (expandedPhase) {
      const element = document.getElementById(expandedPhase);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, []);

  return (
    <div className={classes.pagePadding}>
      <header
        className={classNames(
          classes.marginBottom4,
          classes.colorWhite,
          classes.flexSpacebetween,
        )}
      >
        <div>
          <h1
            className={classNames(
              classes.marginBottom0,
              classes.flexCenter,
              classes.gap1,
              classes.svgContainer,
            )}
          >
            <EllisIcon />
            <span>AI in SDLC</span>
          </h1>
          <div className={classes.subHeading}>
            Integrating AI capabilities in software engineering to deliver world
            class product quality
          </div>
        </div>
        <div>
          <EmeraldButton
            label="Summarized View"
            onClick={ev => {
              ev.preventDefault();
              window.open(
                'https://cbre.sharepoint.com/sites/intra-DigitalTechnology/SitePages/Products-To-Platforms/AI-in-SDLC.aspx',
                '_blank',
              );
            }}
          />
        </div>
      </header>

      <main
        className={classNames(
          classes.padding2Point5,
          classes.bgWhiteAppha8,
          classes.borderRadius1,
        )}
      >
        <Grid container spacing={3}>
          {sdlcData?.phases?.map((phase: IPhaseCard) => {
            return (
              <Grid item xs={12} key={phase.id} id={phase.title}>
                <PhaseCard
                  {...phase}
                  expanded={expandedPhase === phase.title}
                />
              </Grid>
            );
          })}
        </Grid>
      </main>
    </div>
  );
};

export default AiInSdlc;
